import appointmentController from './appointmentController'

export default appointmentController



// WEBPACK FOOTER //
// ../src/controllers/appointmentController/index.js